import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'default' | 'large';
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  variant = 'primary',
  size = 'default',
  onClick,
  href,
  className = ''
}: CTAButtonProps) {
  const baseStyles = 'font-semibold rounded-lg transition-all duration-200 inline-block text-center cursor-pointer';
  const variantStyles = {
    primary: 'bg-teal text-white hover:bg-teal-dark shadow-lg hover:shadow-xl',
    secondary: 'bg-white text-navy border-2 border-navy hover:bg-navy hover:text-white'
  };
  const sizeStyles = {
    default: 'px-8 py-3 text-base',
    large: 'px-12 py-4 text-lg'
  };
  const handleClick = (e: React.MouseEvent) => {
    if (href) {
      e.preventDefault();
      // Check if it's an anchor link (starts with #) or external URL
      if (href.startsWith('#')) {
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      } else {
        // External URL - redirect
        window.location.href = href;
      }
    }
    if (onClick) {
      onClick();
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`} data-id="element-13">
      {children}
    </motion.button>;
}